var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.polls),function(poll){return _c('li',{key:poll.id},[_c('poll-card',{attrs:{"poll":poll,"user":_vm.user},on:{"updatePoll":_vm.updatePoll,"copyPoll":_vm.copyPoll,"leavePoll":_vm.leavePoll}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }